export function useAccessDeniedModal() {
    const isOpen = useState('access-denied-modal-open', () => false)

    function show() {
        isOpen.value = true
    }

    function close() {
        isOpen.value = false
    }

    return {
        isOpen,
        show,
        close,
    }
}
